import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const AbandonmentIntelligence = lazy(() => import('../AbandonmentIntelligence'));

const abandonmentIntelligenceRoute: RouteObject = {
  path: '/abandonment-intelligence',
  element: <AbandonmentIntelligence />,
};

export default abandonmentIntelligenceRoute;
